import { render, staticRenderFns } from "./PageSpinner.vue?vue&type=template&id=9ff51666&scoped=true"
import script from "./PageSpinner.vue?vue&type=script&lang=js"
export * from "./PageSpinner.vue?vue&type=script&lang=js"
import style0 from "./PageSpinner.vue?vue&type=style&index=0&id=9ff51666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff51666",
  null
  
)

export default component.exports